import { NgModule } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SpinnerComponent } from 'src/app/utility/spinner/spinner.component';
import { MinorsProfileComponent } from './minors-profile/minors-profile.component';
import { TutorProfileComponent } from './tutor-profile/tutor-profile.component';
import { MatTabsModule } from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatGridListModule} from '@angular/material/grid-list';
import { FormFieldsComponent } from 'src/app/utility/form-fields/form-fields.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { MinorComponent } from './minors-profile/minor/minor.component';
import { TranslationPipe } from '../../pipes/translation.pipe';
import { ModalComponent } from '../../utility/modal/modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    HomeComponent,
    MinorsProfileComponent,
    TutorProfileComponent,
    FormFieldsComponent,
    MinorComponent,
    ModalComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SpinnerComponent,
    MatTabsModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    MatExpansionModule,
    NgFor,
    TranslationPipe,
    NgbModule,
    FormsModule, ReactiveFormsModule, NgxSpinnerModule  ],
  exports:[TranslationPipe],
  providers:[TranslationPipe]
})
export class HomeModule { }
